import { composeStyle } from '@xhs/yam-beer/core/system/compose'
import { registerThemeSpec } from '@xhs/yam-beer/core/system/utils/themeSpec'

const errorState = '&[data-error]'
const disabledState = '&:not([data-error])[disabled]'
const hoverState = '&:not([disabled]):not([data-error]):hover, &:not([disabled]):not([data-error])[data-hover]'
const activeState = '&:not([disabled]):not([data-error]):active, &:not([disabled]):not([data-error])[active]'

export default function initStyle() {
  return [
    registerThemeSpec('cmp.imageUpload', {
      card: {
        mb: '2x',
        display: 'inline-flex',
        flexDirection: 'column',
      },
      drop: {
        width: 104,
        height: 104,
        borderRadius: 'control',
        border: 'outlineoutline',
        borderStyle: 'dashed',
        overflow: 'hidden',
        mx: 'x',
      },
      cardState: {
        local: {
          [errorState]: {
            '[data-slot="box"]': {
              borderColor: 'danger',
            },
          },
        },
        default: {
          cursor: 'pointer',
          [errorState]: {
            '[data-slot="box"]': {
              borderColor: 'danger',
            },
          },
          [activeState]: {
            '[data-slot="box"]': {
              borderColor: 'palette.brand.active',
            },
          },
          [disabledState]: {
            cursor: 'not-allowed',
            '[data-slot="box"]': {
              opacity: 0.3,
              cursor: 'not-allowed',
              bg: '#fbfbfb',
            },
          },
          [hoverState]: {
            '[data-slot="box"]': {
              borderColor: 'brand',
            },
            img: {
              transform: 'scale(1.5)',
            },
            '[data-slot="filename"]': {
              color: composeStyle.when('error')
                .truthy('danger')
                .falsy('brand'),
            },
          },
        },
      },
      box: {
        width: 104,
        height: 104,
        display: 'flex',
        position: 'relative',
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: 'control',
        border: 'outlineoutline',
        overflow: 'hidden',
        p: 0,
      },
      boxVariant: {
        mask: {
          position: 'absolute',
          right: 0,
          top: 0,
          left: 0,
          bottom: 0,
          background: 'rgba(255,255,255,0.7)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          '&[data-loading]': {
            cursor: 'wait',
          },
        },
        img: {
          bg: '#fbfbfb',
        },
        new: {
          boxSizing: 'borderBox',
          cursor: 'pointer',
          borderStyle: 'dashed',
        },
      },
      img: {
        transition: 'transform 0.3s ease',
        width: '104px',
        height: '104px',
        objectFit: 'contain',
      },
      fileName: {
        width: 104,
        textAlign: 'center',
        fontSize: '12px',
        lineHeight: '18px',
        color: 'mute',
        pt: 'x',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        [errorState]: {
          color: 'danger',
        },
      },

      cardList: {
        display: 'inline-flex',
        flexWrap: 'wrap',
        alignItems: 'flex-start',
      },

      tips: {
        mb: '2x',
        pt: '5px',
        lineHeight: '22px',
        color: 'mute',
        fontSize: '14px',
      },
      retryBtn: {
        cursor: 'pointer',
        svg: {
          fill: 'danger',
        },
        [hoverState]: {
          svg: {
            fill: 'palette.danger.hover',
          },
        },
        [activeState]: {
          svg: {
            fill: 'palette.danger.active',
          },
        },
      },
    }),
  ]
}
